import { bindAudioReady } from '~/utils/TTSRecorder/tts'

export default defineNuxtPlugin(() => {
  bindAudioReady()
})
